import { useEffect } from 'react';
import { useTransactionsFetcher } from './useTransactionsFetcher';
import { useTransactionFilters } from './useTransactionFilters';

interface UseTransactionsManagerOptions {
  limit?: number;
  initialStatus?: string;
}

export function useTransactionsManager({
  limit = 100,
  initialStatus
}: UseTransactionsManagerOptions = {}) {
  const {
    transactions,
    loading,
    isFetchingFresh,
    error,
    hasMore,
    hasStripeAccount,
    hasTransactions,
    loadMore,
    loadTransactions,
    forceRefresh,
    accountId,
    currentStatus,
    setCurrentStatus,
  } = useTransactionsFetcher({ limit, initialStatus });

  const {
    filteredTransactions,
    filterByStatus,
    filterByPaymentMethod,
    filterByKeepMore,
    filterByMinAmount
  } = useTransactionFilters({ transactions });

  // Initialize with the provided status
  useEffect(() => {
    if (initialStatus && initialStatus !== currentStatus) {
      console.log(`[TransactionsManager] Initializing with status: ${initialStatus}`);
      setCurrentStatus(initialStatus);
    }
  }, [initialStatus, currentStatus, setCurrentStatus]);

  // Function to manually refresh transactions — uses forceRefresh from fetcher
  const refreshTransactions = () => {
    if (forceRefresh) {
      return forceRefresh();
    } else if (accountId) {
      return loadTransactions(undefined, accountId, currentStatus);
    }
  };

  return {
    transactions: filteredTransactions,
    loading,
    isFetchingFresh,
    error,
    hasMore,
    loadMore,
    refreshTransactions,
    filterByStatus: (status?: string) => {
      setCurrentStatus(status);
      filterByStatus(status);
    },
    filterByPaymentMethod,
    filterByKeepMore,
    filterByMinAmount,
    hasStripeAccount,
    hasTransactions
  };
}
